export const resetPasswordFormFields = [
    {
        tagType: "regular",
        label: "Your registered email address",
        id: "registeredEmail",
        name: "registeredEmail",
        type: "text",
        placeholder: "Enter your registered email",
    }
]